import jwtDecode from "jwt-decode";

const tokenKey = 'senso-token';
const refreshTokenKey = 'senso-refresh-token';
const impersonateKey = 'senso-impersonate-user';

const getToken = () => {
  return localStorage.getItem(tokenKey);
}

const setToken = (token) => {
  localStorage.setItem(tokenKey, token);
}

const unsetToken = () => {
  localStorage.removeItem(tokenKey);
}

const getRefreshToken = () => {
  return localStorage.getItem(refreshTokenKey);
}

const setRefreshToken = (refreshToken) => {
  localStorage.setItem(refreshTokenKey, refreshToken);
}

const unsetRefreshToken = () => {
  localStorage.removeItem(refreshTokenKey);
}

const tokenExpiresAt = (token) => {
  const payload = jwtDecode(token);
  return (payload.exp * 1000);
}

const unsetImpersonate = () => {
  localStorage.removeItem(impersonateKey);
}

export {
  getToken,
  setToken,
  unsetToken,
  getRefreshToken,
  setRefreshToken,
  unsetRefreshToken,
  tokenExpiresAt,
  unsetImpersonate
}